unit View.Modulos.Edit;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, WEBLib.StdCtrls,

  Bcl.Rtti.Common, XData.Web.Client, Data.DB, WEBLib.CDS,
  WEBLib.DBCtrls, XData.Web.JsonDataset, XData.Web.Dataset, JS,

  App.Types, Crud.Utils, WEBLib.DB, WEBLib.Controls, WEBLib.ExtCtrls;

type
  TFViewModulosEdit = class(TForm)
    pnlMessage: TPanel;
    lbMessage: TLabel;
    btCloseMessage: TButton;
    DataSource: TDatasource;
    btCancel: TButton;
    btSave: TButton;
    btDelete: TButton;
    lbid: TLabel;
    edid: TDBEdit;
    lbnome: TLabel;
    ednome: TDBEdit;
    lbcodigo_interno: TLabel;
    edcodigo_interno: TDBEdit;
    lbexcluido: TLabel;
    edexcluido: TDBEdit;
    lbinclusao: TLabel;
    edinclusao: TDBEdit;
    lbalteracao: TLabel;
    edalteracao: TDBEdit;
    lbexclusao: TLabel;
    edexclusao: TDBEdit;
    XDataClientModulosGet: TXDataWebClient;
    XDataClientModulosDelete: TXDataWebClient;
    ModulosDataset: TXDataWebDataSet;
    ModulosDatasetid: TIntegerField;
    ModulosDatasetnome: TStringField;
    ModulosDatasetcodigo_interno: TIntegerField;
    ModulosDatasetexcluido: TBooleanField;
    ModulosDatasetinclusao: TDateTimeField;
    ModulosDatasetalteracao: TDateTimeField;
    ModulosDatasetexclusao: TDateTimeField;
    procedure btCloseMessageClick(Sender: TObject);
    procedure btCancelClick(Sender: TObject);
    procedure btSaveClick(Sender: TObject);
    procedure btDeleteClick(Sender: TObject);
    procedure XDataClientModulosGetLoad(Response: TXDataClientResponse);
    procedure XDataClientModulosDeleteLoad(Response: TXDataClientResponse);
    procedure XDataClientModulosDeleteError(Error: TXDataClientError);
    procedure ModulosDatasetAfterApplyUpdates(Sender: TDataSet;
      Info: TResolveResults);
    procedure WebFormCreate(Sender: TObject);
  private
    FId: JSValue;
    FShowListProc: TListProc;
    procedure InsertEntity;
    procedure LoadEntity;
    procedure ShowNotification(Notification: string);
    procedure HiddenNotification;
    class function InternalCreateForm(AElementID: string;
      AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm; overload;
  protected
    FInserting: Boolean;
  public
    class function CreateForm(AElementID: string;
      AShowListProc: TListProc; AId: JSValue): TForm; overload;
  protected procedure LoadDFMValues; override; end;

var
  FViewModulosEdit: TFViewModulosEdit;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewModulosEdit }

procedure TFViewModulosEdit.btSaveClick(Sender: TObject);
begin
  if ModulosDataset.State in dsEditModes then
  begin
        ModulosDataset.Post;
    ModulosDataset.ApplyUpdates;
  end
  else
    FShowListProc;
end;

procedure TFViewModulosEdit.btDeleteClick(Sender: TObject);
begin
  if ModulosDataset.State in dsEditModes then
    ModulosDataset.Post;
  XDataClientModulosDelete.Delete(ModulosDataset.EntitySetName,
    TJSObject(ModulosDataset.CurrentData));
end;


class function TFViewModulosEdit.CreateForm(AElementID: string;
  AShowListProc: TListProc; AId: JSValue): TForm;
var
  Inserting: Boolean;
begin
  Inserting := isNull(AId);
  Result := InternalCreateForm(AElementID, AShowListProc, Inserting, AId);
end;

procedure TFViewModulosEdit.HiddenNotification;
begin
  pnlMessage.ElementHandle.hidden := True;
end;

procedure TFViewModulosEdit.InsertEntity;
begin
  ModulosDataset.Close;
  ModulosDataset.SetJsonData('{}');
  ModulosDataset.Open;
  ModulosDataset.Insert;
end;

class function TFViewModulosEdit.InternalCreateForm(AElementID: string;
  AShowListProc: TListProc; AInserting: Boolean; AId: JSValue): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewModulosEdit(AForm).FInserting := AInserting;
    TFViewModulosEdit(AForm).FId := AId;
    TFViewModulosEdit(AForm).FShowListProc := AShowListProc;
    if AInserting then
      TFViewModulosEdit(AForm).InsertEntity
    else
      TFViewModulosEdit(AForm).LoadEntity;
    TFViewModulosEdit(AForm).btDelete.Enabled := not AInserting;
  end;

begin
  Application.CreateForm(TFViewModulosEdit, AElementID, Result, @AfterCreate);
end;

procedure TFViewModulosEdit.LoadEntity;
var
  QueryString: string;
begin
  QueryString := TCrudUtils.GetEntityGetQueryString(
    ModulosDataset.Connection.Model.DefaultSchema.FindEntityType(
      ModulosDataset.EntitySetName
    )
  );
  XDataClientModulosGet.Get(ModulosDataset.EntitySetName, QueryString, FId);
end;

procedure TFViewModulosEdit.ShowNotification(Notification: string);
begin
  lbMessage.Caption := Notification;
  pnlMessage.ElementHandle.hidden := False;
end;

procedure TFViewModulosEdit.btCloseMessageClick(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewModulosEdit.WebFormCreate(Sender: TObject);
begin
  HiddenNotification;
end;

procedure TFViewModulosEdit.XDataClientModulosGetLoad(Response: TXDataClientResponse);
begin
  ModulosDataset.Close;
  ModulosDataset.SetJsonData(Response.Result);
  ModulosDataset.Open;
  
  ModulosDataset.Edit;  
end;

procedure TFViewModulosEdit.XDataClientModulosDeleteError(
  Error: TXDataClientError);
begin
  ShowNotification(Error.ErrorMessage);
end;

procedure TFViewModulosEdit.XDataClientModulosDeleteLoad(
  Response: TXDataClientResponse);
begin
  FShowListProc;
end;

procedure TFViewModulosEdit.ModulosDatasetAfterApplyUpdates(Sender: TDataSet;
  Info: TResolveResults);
var
  I: integer;
  ResolveInfo: TResolveInfo;
begin
  for I := 0 to Length(Info.Records) - 1 do
  begin
    ResolveInfo := Info.Records[I];
//    if ResolveInfo.ResolveStatus = TResolveStatus.rsResolveFailed then
    if ResolveInfo.Error <> '' then
    begin
      ShowNotification(ResolveInfo.Error);
      Exit;
    end;
  end;
  FShowListProc;
end;

procedure TFViewModulosEdit.btCancelClick(Sender: TObject);
begin
  FShowListProc;
end;

procedure TFViewModulosEdit.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlMessage := TPanel.Create('view.modulos.form.message');
  lbMessage := TLabel.Create('view.modulos.form.message.label');
  btCloseMessage := TButton.Create('view.modulos.form.message.button');
  btCancel := TButton.Create('view.modulos.form.btBack');
  btSave := TButton.Create('view.modulos.form.btSave');
  btDelete := TButton.Create('view.modulos.form.btDelete');
  lbid := TLabel.Create('view.modulos.form.lbid');
  edid := TDBEdit.Create('view.modulos.form.edid');
  lbnome := TLabel.Create('view.modulos.form.lbnome');
  ednome := TDBEdit.Create('view.modulos.form.ednome');
  lbcodigo_interno := TLabel.Create('view.modulos.form.lbcodigo_interno');
  edcodigo_interno := TDBEdit.Create('view.modulos.form.edcodigo_interno');
  lbexcluido := TLabel.Create('view.modulos.form.lbexcluido');
  edexcluido := TDBEdit.Create('view.modulos.form.edexcluido');
  lbinclusao := TLabel.Create('view.modulos.form.lbinclusao');
  edinclusao := TDBEdit.Create('view.modulos.form.edinclusao');
  lbalteracao := TLabel.Create('view.modulos.form.lbalteracao');
  edalteracao := TDBEdit.Create('view.modulos.form.edalteracao');
  lbexclusao := TLabel.Create('view.modulos.form.lbexclusao');
  edexclusao := TDBEdit.Create('view.modulos.form.edexclusao');
  DataSource := TDataSource.Create(Self);
  ModulosDataset := TXDataWebDataSet.Create(Self);
  ModulosDatasetid := TIntegerField.Create(Self);
  ModulosDatasetnome := TStringField.Create(Self);
  ModulosDatasetcodigo_interno := TIntegerField.Create(Self);
  ModulosDatasetexcluido := TBooleanField.Create(Self);
  ModulosDatasetinclusao := TDateTimeField.Create(Self);
  ModulosDatasetalteracao := TDateTimeField.Create(Self);
  ModulosDatasetexclusao := TDateTimeField.Create(Self);
  XDataClientModulosGet := TXDataWebClient.Create(Self);
  XDataClientModulosDelete := TXDataWebClient.Create(Self);

  pnlMessage.BeforeLoadDFMValues;
  lbMessage.BeforeLoadDFMValues;
  btCloseMessage.BeforeLoadDFMValues;
  btCancel.BeforeLoadDFMValues;
  btSave.BeforeLoadDFMValues;
  btDelete.BeforeLoadDFMValues;
  lbid.BeforeLoadDFMValues;
  edid.BeforeLoadDFMValues;
  lbnome.BeforeLoadDFMValues;
  ednome.BeforeLoadDFMValues;
  lbcodigo_interno.BeforeLoadDFMValues;
  edcodigo_interno.BeforeLoadDFMValues;
  lbexcluido.BeforeLoadDFMValues;
  edexcluido.BeforeLoadDFMValues;
  lbinclusao.BeforeLoadDFMValues;
  edinclusao.BeforeLoadDFMValues;
  lbalteracao.BeforeLoadDFMValues;
  edalteracao.BeforeLoadDFMValues;
  lbexclusao.BeforeLoadDFMValues;
  edexclusao.BeforeLoadDFMValues;
  DataSource.BeforeLoadDFMValues;
  ModulosDataset.BeforeLoadDFMValues;
  ModulosDatasetid.BeforeLoadDFMValues;
  ModulosDatasetnome.BeforeLoadDFMValues;
  ModulosDatasetcodigo_interno.BeforeLoadDFMValues;
  ModulosDatasetexcluido.BeforeLoadDFMValues;
  ModulosDatasetinclusao.BeforeLoadDFMValues;
  ModulosDatasetalteracao.BeforeLoadDFMValues;
  ModulosDatasetexclusao.BeforeLoadDFMValues;
  XDataClientModulosGet.BeforeLoadDFMValues;
  XDataClientModulosDelete.BeforeLoadDFMValues;
  try
    Name := 'FViewModulosEdit';
    Left := 0;
    Top := 0;
    Width := 593;
    Height := 454;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    TabOrder := 1;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    pnlMessage.SetParentComponent(Self);
    pnlMessage.Name := 'pnlMessage';
    pnlMessage.Left := 296;
    pnlMessage.Top := 113;
    pnlMessage.Width := 273;
    pnlMessage.Height := 60;
    pnlMessage.BorderColor := clSilver;
    pnlMessage.BorderStyle := bsSingle;
    lbMessage.SetParentComponent(pnlMessage);
    lbMessage.Name := 'lbMessage';
    lbMessage.Left := 16;
    lbMessage.Top := 24;
    lbMessage.Width := 42;
    lbMessage.Height := 13;
    lbMessage.Caption := 'Message';
    lbMessage.Transparent := True;
    btCloseMessage.SetParentComponent(pnlMessage);
    btCloseMessage.Name := 'btCloseMessage';
    btCloseMessage.Left := 248;
    btCloseMessage.Top := 11;
    btCloseMessage.Width := 22;
    btCloseMessage.Height := 25;
    btCloseMessage.Caption := 'x';
    btCloseMessage.TabOrder := 0;
    SetEvent(btCloseMessage, Self, 'OnClick', 'btCloseMessageClick');
    btCancel.SetParentComponent(Self);
    btCancel.Name := 'btCancel';
    btCancel.Left := 126;
    btCancel.Top := 394;
    btCancel.Width := 96;
    btCancel.Height := 25;
    btCancel.Caption := 'Cancel';
    btCancel.TabOrder := 1;
    SetEvent(btCancel, Self, 'OnClick', 'btCancelClick');
    btSave.SetParentComponent(Self);
    btSave.Name := 'btSave';
    btSave.Left := 24;
    btSave.Top := 394;
    btSave.Width := 96;
    btSave.Height := 25;
    btSave.Caption := 'Save';
    btSave.TabOrder := 4;
    SetEvent(btSave, Self, 'OnClick', 'btSaveClick');
    btDelete.SetParentComponent(Self);
    btDelete.Name := 'btDelete';
    btDelete.Left := 305;
    btDelete.Top := 394;
    btDelete.Width := 96;
    btDelete.Height := 25;
    btDelete.Caption := 'Delete';
    btDelete.TabOrder := 5;
    SetEvent(btDelete, Self, 'OnClick', 'btDeleteClick');
    lbid.SetParentComponent(Self);
    lbid.Name := 'lbid';
    lbid.Left := 24;
    lbid.Top := 192;
    lbid.Width := 14;
    lbid.Height := 13;
    lbid.Caption := 'id:';
    lbid.Transparent := True;
    edid.SetParentComponent(Self);
    edid.Name := 'edid';
    edid.Left := 221;
    edid.Top := 189;
    edid.Width := 200;
    edid.Height := 21;
    edid.Enabled := True;
    edid.TabOrder := 6;
    edid.Text := 'edid';
    edid.DataField := 'id';
    edid.DataSource := DataSource;
    lbnome.SetParentComponent(Self);
    lbnome.Name := 'lbnome';
    lbnome.Left := 24;
    lbnome.Top := 219;
    lbnome.Width := 14;
    lbnome.Height := 13;
    lbnome.Caption := 'nome:';
    lbnome.Transparent := True;
    ednome.SetParentComponent(Self);
    ednome.Name := 'ednome';
    ednome.Left := 221;
    ednome.Top := 216;
    ednome.Width := 200;
    ednome.Height := 21;
    ednome.Enabled := True;
    ednome.TabOrder := 7;
    ednome.Text := 'ednome';
    ednome.DataField := 'nome';
    ednome.DataSource := DataSource;
    lbcodigo_interno.SetParentComponent(Self);
    lbcodigo_interno.Name := 'lbcodigo_interno';
    lbcodigo_interno.Left := 24;
    lbcodigo_interno.Top := 246;
    lbcodigo_interno.Width := 14;
    lbcodigo_interno.Height := 13;
    lbcodigo_interno.Caption := 'codigo_interno:';
    lbcodigo_interno.Transparent := True;
    edcodigo_interno.SetParentComponent(Self);
    edcodigo_interno.Name := 'edcodigo_interno';
    edcodigo_interno.Left := 221;
    edcodigo_interno.Top := 243;
    edcodigo_interno.Width := 200;
    edcodigo_interno.Height := 21;
    edcodigo_interno.Enabled := True;
    edcodigo_interno.TabOrder := 8;
    edcodigo_interno.Text := 'edcodigo_interno';
    edcodigo_interno.DataField := 'codigo_interno';
    edcodigo_interno.DataSource := DataSource;
    lbexcluido.SetParentComponent(Self);
    lbexcluido.Name := 'lbexcluido';
    lbexcluido.Left := 24;
    lbexcluido.Top := 273;
    lbexcluido.Width := 14;
    lbexcluido.Height := 13;
    lbexcluido.Caption := 'excluido:';
    lbexcluido.Transparent := True;
    edexcluido.SetParentComponent(Self);
    edexcluido.Name := 'edexcluido';
    edexcluido.Left := 221;
    edexcluido.Top := 270;
    edexcluido.Width := 200;
    edexcluido.Height := 21;
    edexcluido.Enabled := True;
    edexcluido.TabOrder := 9;
    edexcluido.Text := 'edexcluido';
    edexcluido.DataField := 'excluido';
    edexcluido.DataSource := DataSource;
    lbinclusao.SetParentComponent(Self);
    lbinclusao.Name := 'lbinclusao';
    lbinclusao.Left := 24;
    lbinclusao.Top := 300;
    lbinclusao.Width := 14;
    lbinclusao.Height := 13;
    lbinclusao.Caption := 'inclusao:';
    lbinclusao.Transparent := True;
    edinclusao.SetParentComponent(Self);
    edinclusao.Name := 'edinclusao';
    edinclusao.Left := 221;
    edinclusao.Top := 297;
    edinclusao.Width := 200;
    edinclusao.Height := 21;
    edinclusao.Enabled := True;
    edinclusao.TabOrder := 10;
    edinclusao.Text := 'edinclusao';
    edinclusao.DataField := 'inclusao';
    edinclusao.DataSource := DataSource;
    lbalteracao.SetParentComponent(Self);
    lbalteracao.Name := 'lbalteracao';
    lbalteracao.Left := 24;
    lbalteracao.Top := 327;
    lbalteracao.Width := 14;
    lbalteracao.Height := 13;
    lbalteracao.Caption := 'alteracao:';
    lbalteracao.Transparent := True;
    edalteracao.SetParentComponent(Self);
    edalteracao.Name := 'edalteracao';
    edalteracao.Left := 221;
    edalteracao.Top := 324;
    edalteracao.Width := 200;
    edalteracao.Height := 21;
    edalteracao.Enabled := True;
    edalteracao.TabOrder := 11;
    edalteracao.Text := 'edalteracao';
    edalteracao.DataField := 'alteracao';
    edalteracao.DataSource := DataSource;
    lbexclusao.SetParentComponent(Self);
    lbexclusao.Name := 'lbexclusao';
    lbexclusao.Left := 24;
    lbexclusao.Top := 354;
    lbexclusao.Width := 14;
    lbexclusao.Height := 13;
    lbexclusao.Caption := 'exclusao:';
    lbexclusao.Transparent := True;
    edexclusao.SetParentComponent(Self);
    edexclusao.Name := 'edexclusao';
    edexclusao.Left := 221;
    edexclusao.Top := 351;
    edexclusao.Width := 200;
    edexclusao.Height := 21;
    edexclusao.Enabled := True;
    edexclusao.TabOrder := 12;
    edexclusao.Text := 'edexclusao';
    edexclusao.DataField := 'exclusao';
    edexclusao.DataSource := DataSource;
    DataSource.SetParentComponent(Self);
    DataSource.Name := 'DataSource';
    DataSource.DataSet := ModulosDataset;
    DataSource.Left := 176;
    DataSource.Top := 56;
    ModulosDataset.SetParentComponent(Self);
    ModulosDataset.Name := 'ModulosDataset';
    ModulosDataset.AfterApplyUpdates := ModulosDatasetAfterApplyUpdates;
    ModulosDataset.EntitySetName := 'Modulos';
    ModulosDataset.Connection := DMConnection.ApiConnection;
    ModulosDataset.Left := 176;
    ModulosDataset.Top := 8;
    ModulosDatasetid.SetParentComponent(ModulosDataset);
    ModulosDatasetid.Name := 'ModulosDatasetid';
    ModulosDatasetid.FieldName := 'id';
    ModulosDatasetid.Required := True;
    ModulosDatasetnome.SetParentComponent(ModulosDataset);
    ModulosDatasetnome.Name := 'ModulosDatasetnome';
    ModulosDatasetnome.FieldName := 'nome';
    ModulosDatasetnome.Required := False;
    ModulosDatasetnome.Size := 255;
    ModulosDatasetcodigo_interno.SetParentComponent(ModulosDataset);
    ModulosDatasetcodigo_interno.Name := 'ModulosDatasetcodigo_interno';
    ModulosDatasetcodigo_interno.FieldName := 'codigo_interno';
    ModulosDatasetcodigo_interno.Required := True;
    ModulosDatasetexcluido.SetParentComponent(ModulosDataset);
    ModulosDatasetexcluido.Name := 'ModulosDatasetexcluido';
    ModulosDatasetexcluido.FieldName := 'excluido';
    ModulosDatasetexcluido.Required := False;
    ModulosDatasetinclusao.SetParentComponent(ModulosDataset);
    ModulosDatasetinclusao.Name := 'ModulosDatasetinclusao';
    ModulosDatasetinclusao.FieldName := 'inclusao';
    ModulosDatasetinclusao.Required := False;
    ModulosDatasetalteracao.SetParentComponent(ModulosDataset);
    ModulosDatasetalteracao.Name := 'ModulosDatasetalteracao';
    ModulosDatasetalteracao.FieldName := 'alteracao';
    ModulosDatasetalteracao.Required := False;
    ModulosDatasetexclusao.SetParentComponent(ModulosDataset);
    ModulosDatasetexclusao.Name := 'ModulosDatasetexclusao';
    ModulosDatasetexclusao.FieldName := 'exclusao';
    ModulosDatasetexclusao.Required := False;
    XDataClientModulosGet.SetParentComponent(Self);
    XDataClientModulosGet.Name := 'XDataClientModulosGet';
    XDataClientModulosGet.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientModulosGet, Self, 'OnLoad', 'XDataClientModulosGetLoad');
    XDataClientModulosGet.Left := 64;
    XDataClientModulosGet.Top := 8;
    XDataClientModulosDelete.SetParentComponent(Self);
    XDataClientModulosDelete.Name := 'XDataClientModulosDelete';
    XDataClientModulosDelete.Connection := DMConnection.ApiConnection;
    SetEvent(XDataClientModulosDelete, Self, 'OnLoad', 'XDataClientModulosDeleteLoad');
    SetEvent(XDataClientModulosDelete, Self, 'OnError', 'XDataClientModulosDeleteError');
    XDataClientModulosDelete.Left := 64;
    XDataClientModulosDelete.Top := 56;
  finally
    pnlMessage.AfterLoadDFMValues;
    lbMessage.AfterLoadDFMValues;
    btCloseMessage.AfterLoadDFMValues;
    btCancel.AfterLoadDFMValues;
    btSave.AfterLoadDFMValues;
    btDelete.AfterLoadDFMValues;
    lbid.AfterLoadDFMValues;
    edid.AfterLoadDFMValues;
    lbnome.AfterLoadDFMValues;
    ednome.AfterLoadDFMValues;
    lbcodigo_interno.AfterLoadDFMValues;
    edcodigo_interno.AfterLoadDFMValues;
    lbexcluido.AfterLoadDFMValues;
    edexcluido.AfterLoadDFMValues;
    lbinclusao.AfterLoadDFMValues;
    edinclusao.AfterLoadDFMValues;
    lbalteracao.AfterLoadDFMValues;
    edalteracao.AfterLoadDFMValues;
    lbexclusao.AfterLoadDFMValues;
    edexclusao.AfterLoadDFMValues;
    DataSource.AfterLoadDFMValues;
    ModulosDataset.AfterLoadDFMValues;
    ModulosDatasetid.AfterLoadDFMValues;
    ModulosDatasetnome.AfterLoadDFMValues;
    ModulosDatasetcodigo_interno.AfterLoadDFMValues;
    ModulosDatasetexcluido.AfterLoadDFMValues;
    ModulosDatasetinclusao.AfterLoadDFMValues;
    ModulosDatasetalteracao.AfterLoadDFMValues;
    ModulosDatasetexclusao.AfterLoadDFMValues;
    XDataClientModulosGet.AfterLoadDFMValues;
    XDataClientModulosDelete.AfterLoadDFMValues;
  end;
end;

end.
